import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../contexts/PermissionsContext';

export default function District({ districts, handleOpenModal, pagination }) {
  const districtData = Array.isArray(districts) ? districts : [];
  const { t } = useTranslation('MasterData');
  const [startIndex, setStartIndex] = useState(0);
  const { permissions } = usePermissions();
  useEffect(() => {
    setStartIndex(pagination.per_page * (pagination.current_page - 1) + 1);
  }, [pagination]);

  return (
    <div className="table-outer distict-table">
      <table className="table">
        <thead>
          <tr className="t-heading">
            <th className="id">
              <h5>#</h5>
            </th>
            <th className="distict-name">
              <h5>{t('DISTRICTNAME')}</h5>
            </th>
            <th className="name">
              <h5>{t('REGION')}</h5>
            </th>
            <th className="action">
              {permissions?.MASTER_DATA_DISTRICT?.edit_permission === 1 && (
                <h5 className="pe-3">{t('ACTION')}</h5>
              )}
            </th>
          </tr>
        </thead>
        <tbody>
          {districtData.length === 0 ? (
            <tr>
              <td colSpan="100%" className="text-center py-4">
                {t('NORECODAVAILABLE')}
              </td>
            </tr>
          ) : (
            districtData?.map((district, index) => (
              <tr key={index}>
                <td className="id">
                  <h5>{index + startIndex}</h5>
                </td>
                <td className="distict-name">
                  <h5>{district.name}</h5>
                </td>
                <td className="name">
                  <h5>
                    {district.region?.name ? district.region?.name : '--'}
                  </h5>
                </td>
                <td className="action">
                  {permissions?.MASTER_DATA_DISTRICT?.edit_permission === 1 && (
                    <>
                      <div div className="d-flex">
                        <button
                          className="edit"
                          onClick={() => handleOpenModal('edit', district)}
                        >
                          <img src="images/green-edit.svg" alt="Edit" />
                        </button>
                        <button
                          className="delete"
                          onClick={() => handleOpenModal('delete', district)}
                        >
                          <img src="images/red-delete.svg" alt="" />
                        </button>
                      </div>
                    </>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
